import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Erros de permissão/validação não melhoram com nova tentativa.
        const message = error instanceof Error ? error.message.toLowerCase() : ''
        if (message.includes('jwt') || message.includes('permission') || message.includes('forbidden')) {
          return false
        }
        return failureCount < 2
      },
    },
    mutations: {
      retry: 0,
    },
  },
})

/** Chaves de cache centralizadas para evitar invalidações inconsistentes. */
export const queryKeys = {
  workspaces: ['workspaces'] as const,
  accounts: (workspaceId: string) => ['accounts', workspaceId] as const,
  posts: (workspaceId: string, filters?: unknown) => ['posts', workspaceId, filters] as const,
  post: (postId: string) => ['post', postId] as const,
  media: (workspaceId: string) => ['media', workspaceId] as const,
  dashboard: (workspaceId: string) => ['dashboard', workspaceId] as const,
  activity: (workspaceId: string) => ['activity', workspaceId] as const,
  insights: (workspaceId: string) => ['insights', workspaceId] as const,
}
